// extracted by mini-css-extract-plugin
export var locationCard = "_f9-0";